//server api endpoints
export const USER_ROUTES = "/api/users"
//for adding styles or brands
export const PRODUCT_ROUTES = "/api/product"
//for getting products by queries r all products
export const PRODUCTS_ROUTES = "/api/products"
//for getting site info
export const SITE_INFO_ROUTES = "/api/site"